var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "wa-busines-customer-groups" } }, [
    _c("div", { staticClass: "main-content" }, [
      _c("div", { staticClass: "header" }, [
        _c(
          "div",
          { staticClass: "title" },
          [
            _c("div", { staticClass: "title-content" }, [
              _c(
                "span",
                {
                  staticStyle: { cursor: "pointer" },
                  on: {
                    click: function ($event) {
                      _vm.selectedCustomerGroup = null
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("wp.customerGroups")) +
                      "\n                    "
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.selectedCustomerGroup
                ? _c("span", [
                    _vm._v(
                      " > " + _vm._s(_vm.selectedCustomerGroup.name) + " "
                    ),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "a-popover",
              {
                attrs: {
                  visible: _vm.createCustomerGroupFormVisible,
                  placement: "bottom",
                  trigger: "click",
                },
                on: { visibleChange: _vm.changeCreateGroupPopupVisible },
              },
              [
                _c(
                  "div",
                  { attrs: { slot: "content" }, slot: "content" },
                  [
                    _c("CreateCustomerGroupWithNumbers", {
                      attrs: {
                        contacts: [],
                        "on-cancelled": function () {
                          return _vm.changeCreateGroupPopupVisible(false)
                        },
                        "on-completed": _vm.customerGroupCreated,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                !_vm.selectedCustomerGroup
                  ? _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: {
                              followCursor: true,
                              placement: "bottom-end",
                            },
                            expression:
                              "{ followCursor: true, placement: 'bottom-end' }",
                          },
                        ],
                        staticClass: "add-button",
                        attrs: { content: _vm.$t("wp.createCustomerGroup") },
                      },
                      [_c("md-icon", [_vm._v("add")])],
                      1
                    )
                  : _vm._e(),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        !_vm.selectedCustomerGroup
          ? _c(
              "div",
              { staticClass: "search-bar" },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.searchText,
                      expression: "searchText",
                    },
                  ],
                  attrs: { placeholder: _vm.$t("wp.search") },
                  domProps: { value: _vm.searchText },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.searchText = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _c("md-icon", [_vm._v("search")]),
              ],
              1
            )
          : _c(
              "div",
              { staticClass: "search-bar" },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.predictiveText,
                      expression: "predictiveText",
                    },
                  ],
                  attrs: { placeholder: "Search" },
                  domProps: { value: _vm.predictiveText },
                  on: {
                    keydown: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      _vm.searchTextOfSelected = _vm.predictiveText
                    },
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.predictiveText = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _c("md-icon", [_vm._v("search")]),
              ],
              1
            ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "group-list-wrapper" },
        [
          !!_vm.customerGroups[
            _vm.customerGroups.findIndex(function (cg) {
              return cg._id === _vm.$_.get(_vm.selectedCustomerGroup, "_id")
            })
          ]
            ? _c("CustomerGroupDetail", {
                key: _vm.$_.get(
                  _vm.customerGroups[
                    _vm.customerGroups.findIndex(function (cg) {
                      return (
                        cg._id === _vm.$_.get(_vm.selectedCustomerGroup, "_id")
                      )
                    })
                  ],
                  "_id"
                ),
                attrs: {
                  searchTextOfSelected: _vm.searchTextOfSelected,
                  "channel-id": _vm.channelId,
                  isWhatsappBusiness: _vm.isWhatsappBusiness(),
                },
                model: {
                  value:
                    _vm.customerGroups[
                      _vm.customerGroups.findIndex(function (cg) {
                        return (
                          cg._id ===
                          _vm.$_.get(_vm.selectedCustomerGroup, "_id")
                        )
                      })
                    ],
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.customerGroups,
                      _vm.customerGroups.findIndex(function (cg) {
                        return (
                          cg._id ===
                          _vm.$_.get(_vm.selectedCustomerGroup, "_id")
                        )
                      }),
                      $$v
                    )
                  },
                  expression:
                    "\n                    customerGroups[\n                        customerGroups.findIndex((cg) => cg._id === $_.get(selectedCustomerGroup, '_id'))\n                    ]\n                ",
                },
              })
            : _c("CustomerGroupsTable", {
                attrs: {
                  groups: _vm.getFilteredRows(),
                  "on-row-selected": _vm.selectCustomerGroup,
                  "on-row-deleted": _vm.customerGroupDeleted,
                },
              }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }